<template>
  <div class="link">
    <div class="title">
      <div
        :class="{
          'title-item': true,
          'title-item-active': active === 'activities',
        }"
        @click="handleActive('activities')"
      >
        Campaigns
      </div>
      <div
        :class="{
          'title-item': true,
          'title-item-active': active === 'keywords',
        }"
        @click="handleActive('keywords')"
      >
        Direct Links
      </div>
    </div>
    <div class="card" v-if="active === 'activities'">
      <a-spin :spinning="spinning">
        <ActivityLinks v-model:active="active"></ActivityLinks>
      </a-spin>
    </div>
    <div class="card" v-if="active === 'keywords'">
      <KeywordLinks></KeywordLinks>
    </div>
  </div>
</template>

<script>
import KeywordLinks from './components/KeywordLinks'
import ActivityLinks from './components/ActivityLinks'
import { mapState } from 'vuex'

export default {
  name: 'Links',
  components: { KeywordLinks, ActivityLinks },
  created() {
    this.$store.dispatch('link/GetAllActivities')
    this.$store.dispatch('base/GetLanguageList')
  },
  computed: {
    ...mapState({
      spinning: (state) => state.link.spinning,
    }),
  },
  data() {
    return {
      active: 'activities',
    }
  },
  methods: {
    handleActive(value) {
      this.active = value
    },
  },
}
</script>

<style lang="scss" scoped>
.link {
  padding: 10px;
  margin-top: 25px;
  user-select: none;
  .title {
    display: flex;
    font-size: 20px;
    color: #333;
    .title-item {
      margin-right: 20px;
      cursor: pointer;
    }
    .title-item-active {
      color: #2486df;
    }
  }
  .card {
    margin-top: 20px;
  }
}
</style>
